export default "__VITE_ASSET__f66154a1__"